import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { KnBrFactSheetEffects } from './kn-br-fact-sheet.effect';
import { KnBrFactSheetReducer } from './kn-br-fact-sheet.reducer';
import { KNBR_FACT_SHEET_FEATURE } from './kn-br-fact-sheet.state';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(KNBR_FACT_SHEET_FEATURE, KnBrFactSheetReducer),
    EffectsModule.forFeature([KnBrFactSheetEffects]),
  ],
})
export class KnBrFactSheetStateModule {}
